import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import { GetUgcSettingsResp, SuggestNpcSettingsReq, SuggestNpcSettingsResp } from '../types/meta';

export const postSuggestNpcSettings = async (
  data: SuggestNpcSettingsReq,
  config?: AxiosRequestConfig
): Promise<SuggestNpcSettingsResp> => {
  const url = '/weaver/api/v1/npc_editor/suggest_npc_settings';
  return await request.post(url, data, config || {});
};

export const postGetUgcSettings = async (
  config?: AxiosRequestConfig
): Promise<GetUgcSettingsResp> => {
  const url = '/weaver/api/v1/npc_editor/get_web_paint_setting';
  return await request.post(url, config || {});
};
